import React from "react";
import styles from "./CustomerFeedback.module.scss";
import homeStyles from "../../../styles/Home.module.scss";
function CustomerFeedback() {
  const customerFeedbackData = [
    {
      id: 1,
      percentage: "270%",
      category:
        "Customer reviews can lead to a significant increase in conversion rates",
    },
    {
      id: 2,
      percentage: "82%",
      category:
        "of consumers actively look for negative reviews to gauge product credibility",
    },
    {
      id: 3,
      percentage: "~50%",
      category:
        "of shoppers require a minimum of a 4-star rating to consider engaging with a business",
    },
    {
      id: 4,
      percentage: "~70%",
      category:
        "of consumers report being influenced by online reviews prior to making a purchase",
    },
    {
      id: 5,
      percentage: "~4.6x",
      category:
        "businesses that engage with customer feedback see a remarkable increase in revenue",
    },
    {
      id: 6,
      percentage: "~93%",
      category:
        "of consumers consult reviews to inform their purchasing decisions",
    },
  ];
  return (
    <div className={styles["reviews-and-rating-wrapper"]}>
      <div className={styles["reviews-and-rating-content"]}>
        <h2>
          Proctoring{" "}
          <span className={homeStyles["span-gradient"]}>
            Customer Feedback{" "}
          </span>
          to understand Global trends
        </h2>
      </div>
      <div className={styles["reviews-and-rating-content"]}>
        {customerFeedbackData?.map(
          (
            item: { id: number; percentage: string; category: string },
            index: number
          ) => (
            <div
              className={styles["reviews-and-rating-items"]}
              key={item.id + index}
            >
              <h4>{item?.percentage}</h4>
              <p>{item?.category}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default CustomerFeedback;
